import {makeStyles} from '@material-ui/core';

export const useStyles = makeStyles({
    contentContainer: {
        padding: '0 !important',
        marginTop: '-1px',
    },
});
